export var PersonalTaxIdConfigsFactory = (function() {
    var getTaxIdConfigs = function(countryCode) {
        switch (countryCode) {
        case 'US':
            return {
                showField: true,
                countryName: 'United States',
                label: 'SSN (Social Security Number)',
                format: '999-99-9999',
                allowData: 'numbers-only',
                fieldInService: 'SSN',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'CA':
            return {
                showField: true,
                countryName: 'Canada',
                label: 'SIN (Social Insurance Number)',
                format: '999-999-999',
                allowData: 'numbers-only',
                fieldInService: 'SSN',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'ES':
            return {
                showField: true,
                countryName: 'Spain',
                label: 'NIF/NIE',
                format: '*-9999999-*',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'FR':
            return {
                showField: true,
                countryName: 'France',
                label: 'Social Security Number',
                format: '9999999999999 99',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '15'
            };
        case 'SG':
            return {
                showField: true,
                countryName: 'Singapore',
                label: 'NRIC (Nation Registration Identity Card)',
                format: 'A9999999A',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'PH':
            return {
                showField: true,
                countryName: 'Philippines',
                label: 'TIN (Tax Identification Number)',
                format: '999-999-999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'MY':
            return {
                showField: true,
                countryName: 'Malaysia',
                label: 'NRIC (Nation Registration Identity Card)',
                format: '999999-99-9999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '12'
            };
        case 'HK':
            return {
                showField: true,
                countryName: 'Hong Kong',
                label: 'HK/Macau ID Number',
                format: '*?*999999*',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'ID':
            return {
                showField: true,
                countryName: 'Indonesia',
                label: 'NPWP (Tax ID number)',
                format: '99.999.999.9-999.999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '15'
            };
        case 'TH':
            return {
                showField: true,
                countryName: 'Thailand',
                label: 'ID Card Number',
                format: '9999999999999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '13'
            };
        case 'AR':
            return {
                showField: true,
                countryName: 'Argentina',
                label: 'DNI (National Identification Number)',
                format: '99999999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '8'
            };
        case 'CO':
            return {
                showField: true,
                countryName: 'Colombia',
                label: 'Citizenship Card',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1'
            };
        case 'MX':
            return {
                showField: true,
                countryName: 'Mexico',
                label: 'Unique Population Registration Code',
                format: '******************',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '18'
            };
        case 'CL':
            return {
                showField: true,
                countryName: 'Chile',
                label: 'RUT (Registro Unico Tributario)',
                format: '99.999.999-9',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'VN':
            return {
                showField: true,
                countryName: 'Vietnam',
                label: 'Identity Card',
                format: '999999999?9?9?9',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '12'
            };
        case 'BN':
            return {
                showField: true,
                countryName: 'Brunei',
                label: 'NRIC/Brunei IC Number',
                format: '**-******',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '8'
            };
        case 'HU':
            return {
                showField: true,
                countryName: 'Hungary',
                label: 'Identification Card/Driving License',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4'
            };
        case 'RO':
            return {
                showField: true,
                countryName: 'Romania',
                label: 'Identification Card number',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4'
            };
        case 'ZA':
            return {
                showField: true,
                countryName: 'South Africa',
                label: 'Identity Number',
                format: '9999999999999',
                allowData: 'numbers-only',
                fieldInService: 'IDENTITY',
                fieldInSAP: 'TAX2',
                maxLength: '13'
            };
        case 'CZ':
            return {
                showField: true,
                countryName: 'Czech Republic',
                label: 'Identification Card number',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4'
            };
        case 'IT':
            return {
                showField: true,
                countryName: 'Italy',
                label: 'Fiscal Code Card',
                format: '****************',
                allowData: 'alphanumerics-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '16'
            };
        case 'RU':
            return {
                showField: true,
                countryName: 'Russia',
                label: 'Passport Number',
                format: '9999999999',
                allowData: 'numbers-only',
                fieldInService: 'PASSPORT',
                fieldInSAP: 'TAX2',
                maxLength: '10'
            };
        case 'SK':
            return {
                showField: true,
                countryName: 'Slovakia',
                label: 'Identification Card number',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4'
            };
        case 'UA':
            return {
                showField: true,
                countryName: 'Ukraine',
                label: 'Passport Number (tooltip with image)',
                format: 'HE999999',
                allowData: 'numbers-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4',
                maxLength: '8'
            };
        case 'NL':
            return {
                showField: true,
                countryName: 'The Netherlands',
                label: 'BSN (personal number) (tooltip)',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'BSN',
                fieldInSAP: 'TAX1'
            };
        case 'PL':
            return {
                showField: true,
                countryName: 'Poland',
                label: 'Identification Card number',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'KPP',
                fieldInSAP: 'TAX4'
            };
        case 'IL':
            return {
                showField: true,
                countryName: 'Israel',
                label: 'Tax ID Number',
                format: '999999999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1',
                maxLength: '9'
            };
        case 'PF':
            return {
                showField: true,
                countryName: 'French Polynesia',
                label: 'Le numero d\'identification de mon parrain',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'N/A',
                fieldInSAP: 'N/A'
            };
        case 'AU':
            return {
                showField: false,
                countryName: 'Australia'
            };
        case 'NZ':
            return {
                showField: false,
                countryName: 'New Zealand'
            };
        case 'GB':
            return {
                showField: false,
                countryName: 'United Kingdom'
            };
        case 'JP':
            return {
                showField: false,
                countryName: 'Japan'
            };
        case 'DE':
            return {
                showField: false,
                countryName: 'Germany'
            };
        case 'NO':
            return {
                showField: false,
                countryName: 'Norway'
            };
        case 'SE':
            return {
                showField: false,
                countryName: 'Sweden'
            };
        case 'AT':
            return {
                showField: false,
                countryName: 'Austria'
            };
        case 'FI':
            return {
                showField: false,
                countryName: 'Finland'
            };
        case 'BE':
            return {
                showField: false,
                countryName: 'Belgium'
            };
        case 'DK':
            return {
                showField: false,
                countryName: 'Denmark'
            };
        case 'IE':
            return {
                showField: false,
                countryName: 'Ireland'
            };
        case 'CH':
            return {
                showField: false,
                countryName: 'Switzerland'
            };
        case 'IS':
            return {
                showField: false,
                countryName: 'Iceland'
            };
        case 'LU':
            return {
                showField: false,
                countryName: 'Luxembourg'
            };
        case 'PT':
            return {
                showField: false,
                countryName: 'Portugal'
            };
        default:
            return null;
        }
    };

    return {
        getTaxIdConfigs: getTaxIdConfigs
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/personal-tax-id-configs.js
// module id = 342
// module chunks = 0